export default class UrlsConfig {
    get testingDocumentsDesign() {
        return {
            to: `${this.settings.to}/testing/documents`,
        };
    }

    get testingMaterialsDesign() {
        return {
            to: `${this.settings.to}/testing/materials`,
        };
    }

    get testingOverviewSettings() {
        return {
            to: `${this.settings.to}/testing/overview`,
        };
    }

    get testingHowItWorksSettings() {
        return {
            to: `${this.settings.to}/testing/how-it-works`,
        };
    }

    get testingTagsSettings() {
        return {
            to: `${this.settings.to}/testing/tags`,
        };
    }

    get testingQuestionsSettings() {
        return {
            to: `${this.settings.to}/testing/questions`,
        };
    }

    get testingTestsSettings() {
        return {
            to: `${this.settings.to}/testing/tests`,
        };
    }

    get testingAssignmentsSettings() {
        return {
            to: `${this.settings.to}/testing/assignments`,
        };
    }

    get testingProgressResultsSettings() {
        return {
            to: `${this.settings.to}/testing/progress-results`,
        };
    }

    get login() {
        return {
            to: "/login",
        }
    }

    get forgotPassword() {
        return {
            to: "/forgot-password",
        }
    }

    get index() {
        return {
            to: "/",
        }
    }

    get profile() {
        return {
            to: "/profile",
        }
    }

    get finance() {
        return {
            to: "/finance",
        }
    }

    get economist() {
        return {
            to: "/economist",
        }
    }

    get knowledgeBase() {
        return {
            to: "/knowledge-base",
        }
    }

    get testing() {
        return {
            to: "/testing",
        }
    }

    get testingKnowledgeBase() {
        return {
            to: `${this.testing.to}/knowledge-base`,
        }
    }

    get testingRecentlyOpened() {
        return {
            to: `${this.testing.to}/recently-opened`,
        }
    }

    get testingMyResults() {
        return {
            to: `${this.testing.to}/my-results`,
        }
    }

    get testingMaterialsQuestions() {
        return {
            to: `${this.testing.to}/materials-questions`,
        }
    }

    public testingKnowledgeBaseMaterial({alias}: { alias: string }) {
        return {
            to: `${this.testingKnowledgeBase.to}/material/${encodeURIComponent(alias)}`,
        };
    }

    public testingQuestion({alias}: { alias: string }) {
        return {
            to: `${this.testing.to}/question/${encodeURIComponent(alias)}`,
        };
    }

    public testingTest({alias}: { alias: string }) {
        return {
            to: `${this.testing.to}/test/${encodeURIComponent(alias)}`,
        };
    }

    public testingTestAttempt({alias, resultId}: { alias: string; resultId: number | string }) {
        return {
            to: `${this.testingTest({alias}).to}/attempt/${resultId}`,
        };
    }

    get knowledgeBaseSearchResults() {
        return {
            to: `${this.knowledgeBase.to}/search-results`,
        }
    }

    public articleOfKnowledgeBase({articleId}: { articleId: string }) {
        return {
            to: `${this.knowledgeBase.to}/article/${articleId}`,
        };
    }

    get page404() {
        return {
            to: "/404",
        }
    }

    get pageForbidden() {
        return {
            to: "/forbidden",
        }
    }

    get createNewOrder() {
        return {
            to: "/create-new-order",
        }
    }

    get errorOrComplain() {
        return {
            to: "/error-or-complain",
        }
    }

    get appeals() {
        return {
            to: "/appeals",
        }
    }

    get appealsCreate() {
        return {
            to: "/appeals/create",
        }
    }

    get appealsView() {
        return {
            to: "/appeals/view",
        }
    }

    get appealsCreateByStaff() {
        return {
            to: "/appeals/create-by-staff",
        }
    }

    get controlPanel() {
        return {
            to: "/control-panel",
        }
    }

    get users() {
        return {
            to: `${this.controlPanel.to}/users`,
        }
    }

    get inControlPanelCreateUser() {
        return {
            to: `${this.controlPanel.to}/users/create`,
        }
    }

    get inControlPanelEditUser() {
        return {
            to: `${this.controlPanel.to}/users/edit`,
        };
    }

    get applicationsForChangePersonalData() {
        return {
            to: `${this.controlPanel.to}/applications-for-change-personal-data`,
        }
    }

    get inControlPanelViewApplicationForChangePersonalData() {
        return {
            to: `${this.applicationsForChangePersonalData.to}/view-application`,
        }
    }

    /**
     * @deprecated
     */
    get inControlPanelFeedback() {
        return {
            to: `${this.controlPanel.to}/feedback`,
        }
    }

    get registerNewPartner() {
        return {
            to: `${this.controlPanel.to}/register-new-partner`,
        }
    }

    get editPartner() {
        return {
            to: `${this.controlPanel.to}/edit-partner`,
        }
    }

    get partnerProfile() {
        return {
            to: `${this.controlPanel.to}/partner-profile`,
        }
    }

    get banner() {
        return {
            to: `${this.controlPanel.to}/banner`,
        }
    }

    get inControlPanelBannerCreate() {
        return {
            to: `${this.controlPanel.to}/banner/create`,
        }
    }

    get inControlPanelBannerEdit() {
        return {
            to: `${this.controlPanel.to}/banner/edit`,
        }
    }

    get inControlPanelKnowledgeBase() {
        return {
            to: `${this.controlPanel.to}/knowledge-base`,
        }
    }

    get inControlPanelKnowledgeBaseCreateArticle() {
        return {
            to: `${this.inControlPanelKnowledgeBase.to}/create-article`,
        }
    }

    get inControlPanelKnowledgeBaseEditArticle() {
        return {
            to: `${this.inControlPanelKnowledgeBase.to}/edit-article`,
        }
    }

    get inControlPanelKnowledgeBaseSearch() {
        return {
            to: `${this.inControlPanelKnowledgeBase.to}/search`,
        }
    }

    get referenceBooks() {
        return {
            to: "/reference-books",
        }
    }

    get referenceBooksLists() {
        return {
            to: `${this.referenceBooks.to}/lists`,
        }
    }

    get referenceBooksRules() {
        return {
            to: `${this.referenceBooks.to}/rules`,
        }
    }

    get referenceBooksShowcase() {
        return {
            to: `${this.referenceBooks.to}/showcase`,
        }
    }

    get referenceBooksListsSectionsDescriptions() {
        return {
            to: `${this.referenceBooksLists.to}/sections-descriptions`,
        }
    }

    get referenceBooksListsActionsDescriptions() {
        return {
            to: `${this.referenceBooksLists.to}/actions-descriptions`,
        }
    }

    get referenceBooksAnalysisOrderForm() {
        return {
            to: `${this.referenceBooksRules.to}/analysis-order-form`,
        }
    }

    get referenceBookTicketTypes() {
        return {
            to: `${this.referenceBooksLists.to}/ticket-types`,
        }
    }

    get referenceBookTicketUrgency() {
        return {
            to: `${this.referenceBooksLists.to}/ticket-urgency`,
        }
    }

    get referenceBookTicketStatuses() {
        return {
            to: `${this.referenceBooksLists.to}/ticket-statuses`,
        }
    }

    get referenceBookTicketResponsesStandards() {
        return {
            to: `${this.referenceBooksLists.to}/standards-for-ticket-responses`,
        }
    }

    get referenceBookLabWorkingHours() {
        return {
            to: `${this.referenceBooksLists.to}/lab-working-hours`,
        }
    }

    get referenceBookStaffWorkingHours() {
        return {
            to: `${this.referenceBooksLists.to}/staff-working-hours`,
        }
    }

    get referenceBookCountries() {
        return {
            to: `${this.referenceBooksLists.to}/countries`,
        }
    }

    get referenceBookCities() {
        return {
            to: `${this.referenceBooksLists.to}/cities`,
        }
    }

    get referenceBookCategoriesOfSamples() {
        return {
            to: `${this.referenceBooksLists.to}/categories-of-samples`,
        }
    }

    get referenceBookDNATests() {
        return {
            to: `${this.referenceBooksLists.to}/dna-tests`,
        }
    }

    get referenceBookDefinitionOfSKUs() {
        return {
            to: `${this.referenceBooksLists.to}/definition-of-skus`,
        }
    }

    get referenceBookCountriesLegalForms() {
        return {
            to: `${this.referenceBooksLists.to}/countries-with-olf`,
        }
    }

    get referenceBookCountriesRequisites() {
        return {
            to: `${this.referenceBooksLists.to}/countries-with-requisites`,
        }
    }

    get referenceBookLegalFormRequisiteRules() {
        return {
            to: `${this.referenceBooksLists.to}/legal-form-requisite-rules`,
        }
    }

    get ordersAndAppointments() {
        return {
            to: "/orders-and-appointments",
        }
    }

    get testOrdersDesign() {
        return {
            to: "/test-orders-design",
        }
    }

    get confirmationRequests() {
        return {
            to: "/confirmation-requests",
        }
    }

    get readyTests() {
        return {
            to: "/ready-tests",
        }
    }

    get orders() {
        return {
            to: this.ordersAndAppointments.to,
        }
    }

    get allOrders() {
        return {
            to: this.ordersAndAppointments.to,
        }
    }

    get openedOrder() {
        return {
            to: "/my-orders/order",
        }
    }

    public orderLabQuestions({orderId, questionId}: { orderId: string | number, questionId: string | number }) {
        return {
            to: `/my-orders/order/${orderId}/order-lab-questions/${questionId}`,
        }
    }

    public editOrder({orderId}: { orderId: string | number }) {
        return {
            to: `/my-orders/order/${orderId}/edit`,
        }
    }

    get printAllSamplesPage() {
        return {
            to: "/print-samples/all/order",
        }
    }

    public printSingleSample({orderId, participantId}: { orderId: string, participantId: string }) {
        return {
            to: `/print-samples/single/order/${orderId}/participant/${participantId}`,
        };
    }

    get printOrderForm() {
        return {
            to: "/print-order-form",
        }
    }

    get statistics() {
        return {
            to: `${this.controlPanel.to}/statistics`,
        }
    }

    get statsRecordingsToPartners() {
        return {
            to: `${this.statistics.to}/recordings-to-partners`,
        }
    }

    get statsAppeals() {
        return {
            to: `${this.statistics.to}/appeals`,
        }
    }

    get statsTicketMessageParsing() {
        return {
            to: `${this.statistics.to}/ticket-message-parsing`,
        }
    }

    get statsAppealsPartnerRating() {
        return {
            to: `${this.statistics.to}/appeals-partner-rating`,
        }
    }

    get partnerTraining() {
        return {
            to: "/partner-training",
        }
    }

    get responseTime() {
        return {
            to: `${this.statistics.to}/response-time`,
        }
    }

    get referenceBookDocumentTypes() {
        return {
            to: `${this.referenceBooksLists.to}/document-types`,
        }
    }

    get massiveManagerReplacement() {
        return {
            to: `${this.controlPanel.to}/massive-manager-replacement-among-partners`,
        }
    }

    get managerTransfer() {
        return {
            to: '/manager-transfer',
        }
    }

    get referenceBookLaboratoryLegalEntities() {
        return {
            to: `${this.referenceBooksLists.to}/laboratory-legal-entities`,
        }
    }

    get referenceBookDocumentStatuses() {
        return {
            to: `${this.referenceBooksLists.to}/document-statuses`,
        }
    }

    get referenceBookErrors() {
        return {
            to: `${this.referenceBooksLists.to}/errors`,
        }
    }

    get referenceBookFamilySteps() {
        return {
            to: `${this.controlPanel.to}/reference-books/family-steps`,
        }
    }

    get referenceBookAttributeSelectionRules() {
        return {
            to: `${this.controlPanel.to}/reference-books/attribute-selection-rules`,
        }
    }

    get referenceBookAttributeRuleForNParticipants() {
        return {
            to: `${this.controlPanel.to}/reference-books/attribute-rule-for-n-participants`,
        }
    }

    get referenceBookDescribeKinshipSurvey() {
        return {
            to: `${this.controlPanel.to}/reference-books/describe-kinship-survey`,
        }
    }

    get referenceBookPedigrees() {
        return {
            to: `${this.controlPanel.to}/reference-books/pedigrees`,
        }
    }

    get inControlPanelLaboratoryClarifications() {
        return {
            to: `${this.controlPanel.to}/laboratory-clarifications`,
        }
    }

    get referenceBookLaboratoryQuestionsStatuses() {
        return {
            to: `${this.referenceBooksLists.to}/laboratory-questions-statuses`,
        }
    }

    get referenceBookTemplateQuestions() {
        return {
            to: `${this.referenceBooksLists.to}/template-questions`,
        }
    }

    get referenceBookAnswerTypeRules() {
        return {
            to: `${this.referenceBooksLists.to}/answer-type-rules`,
        }
    }

    get referenceBookEditAnswerTypeRule() {
        return {
            to: `${this.referenceBooksLists.to}/answer-type-rules/edit`,
        }
    }

    get referenceBookCreateAnswerTypeRule() {
        return {
            to: `${this.referenceBooksLists.to}/answer-type-rules/create`,
        }
    }

    get referenceBookFileMeanings() {
        return {
            to: `${this.referenceBooksLists.to}/file-meanings`,
        }
    }

    get referenceBookFileExtensions() {
        return {
            to: `${this.referenceBooksLists.to}/file-extensions`,
        }
    }

    get loginAsUser() {
        return {
            to: "/login-as-user",
        }
    }

    get settings() {
        return {
            to: "/settings",
        }
    }

    get rolesSettings() {
        return {
            to: `${this.settings.to}/roles`,
        }
    }

    get sectionsSettings() {
        return {
            to: `${this.settings.to}/sections`,
        }
    }

    get permissionsSettings() {
        return {
            to: `${this.settings.to}/permissions`,
        }
    }

    get menuSettings() {
        return {
            to: `${this.settings.to}/menu`,
        }
    }

    get testingTopicsSettings() {
        return {
            to: `${this.settings.to}/testing/topics`,
        }
    }

    get resultFileIssuesSettings() {
        return {
            to: `${this.settings.to}/result-file-issues`,
        }
    }

    get orderB24StatusMismatchesSettings() {
        return {
            to: `${this.settings.to}/result-file-status-mismatches`,
        }
    }

    get ticketNotificationSettings() {
        return {
            to: `${this.settings.to}/ticket-notification-settings`,
        }
    }

    get referenceBookOrderLegalStatus() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/order-legal-status`,
        }
    }

    get referenceBookResearchSign() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/research-sign`,
        }
    }

    get referenceBookOrderTerm() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/order-term`,
        }
    }

    get referenceBookSampleType() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/sample-type`,
        }
    }

    get referenceBookNonstandardConsentFiles() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/nonstandard-consent-files`,
        }
    }

    get referenceBookSampling() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/sampling`,
        }
    }

    get referenceBookFamilyLink() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/family-link`,
        }
    }

    get referenceBookAdditionalService() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/additional-service`,
        }
    }

    get referenceBookGender() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/gender`,
        }
    }

    get referenceBookIdentityDoc() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/identity-documents`,
        }
    }

    get referenceBookSubmittedDocuments() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/submitted-documents`,
        }
    }

    get referenceBookAnalysis() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/analysis`,
        }
    }

    get referenceBookOrderFormFields() {
        return {
            to: `${this.referenceBooksAnalysisOrderForm.to}/order-form-fields`,
        }
    }

    get referenceBookPartnersProductCatalog() {
        return {
            to: `${this.referenceBooksLists.to}/partners-product-catalog`,
        }
    }

    get referenceBookClientsProductCatalog() {
        return {
            to: `${this.referenceBooksLists.to}/clients-product-catalog`,
        }
    }

    get massiveMailing() {
        return {
            to: `${this.controlPanel.to}/massive-mailing`,
        }
    }

    get referenceBookTicketTemplates() {
        return {
            to: `${this.referenceBooksLists.to}/ticket-templates`,
        }
    }

    get referenceBooksPriceCalculation() {
        return {
            to: `${this.referenceBooksRules.to}/price-calculation`,
        }
    }

    get referenceBookPriceCalculationAnalysis() {
        return {
            to: `${this.referenceBooksPriceCalculation.to}/analysis`,
        }
    }

    get referenceBookPriceCalculationAdditionalServices() {
        return {to: `${this.referenceBooksPriceCalculation.to}/additional-services`}
    }

    get referenceBookPriceCalculationParticipantLimits() {
        return {to: `${this.referenceBooksPriceCalculation.to}/participant-limits`}
    }

    get referenceBookPriceCalculationSamplesLimits() {
        return {to: `${this.referenceBooksPriceCalculation.to}/samples-limits`}
    }

    get referenceBookPriceCalculationSamples() {
        return {to: `${this.referenceBooksPriceCalculation.to}/samples`}
    }

    get referenceBookPriceCalculationParticipants() {
        return {to: `${this.referenceBooksPriceCalculation.to}/additional-participants`}
    }

    get referenceBookLkNotification() {
        return {to: `${this.referenceBooksLists.to}/lk-notification`}
    }

    get referenceBookNotificationLogs() {
        return {to: '/notification-logs'}
    }

    get referenceBookB24Sync() {
        return {to: `${this.referenceBooksRules.to}/b24-sync`}
    }

    get referenceBookTableFields() {
        return { to: `${this.referenceBooksLists.to}/table-fields` }
    }

    get referenceBookB24FieldMapping() {
        return { to: `${this.referenceBooksLists.to}/b24-field-mapping` }
    }

    get referenceBookSyncGroupFields() {
        return { to: `${this.referenceBooksLists.to}/sync-group-fields` }
    }

    get referenceBookB24Stages() {
        return { to: `${this.referenceBooksLists.to}/b24-stages` }
    }

    get referenceBookChecksumErrors() {
        return { to: `${this.referenceBooksLists.to}/checksum-errors` }
    }

    get referenceBookSettings() {
        return { to: `${this.referenceBooksRules.to}/settings` }
    }

    get referenceBookAppealsRules() {
        return { to: `${this.referenceBooksRules.to}/appeals/super-statuses-statuses-tags-buttons` }
    }

    get referenceBookButtonReferences() {
        return {to: `${this.referenceBooksRules.to}/button-references`}
    }

    get referenceBookNotificationRules() {
        return {to: `${this.referenceBooksRules.to}/notifications`}
    }

    get referenceBookB24StagesNew() {
        return { to: `${this.referenceBooksLists.to}/b24-stages-func-desc` }
    }

    get referenceBookB24SmartProcesses() {
        return { to: `${this.referenceBooksLists.to}/b24-smart-processes` }
    }

    get referenceBookB24Funnels() {
        return { to: `${this.referenceBooksLists.to}/b24-funnels` }
    }

    get referenceBookB24Fields() {
        return { to: `${this.referenceBooksLists.to}/b24-fields` }
    }

    get referenceBookB24BusinessProcesses() {
        return { to: `${this.referenceBooksLists.to}/b24-business-processes` }
    }

    get referenceBookLisEntities() {
        return { to: `${this.referenceBooksLists.to}/lis-entities` }
    }

    get referenceBookEntities1C() {
        return { to: `${this.referenceBooksLists.to}/entities-1c` }
    }

    get referenceBookFunctionDescriptionTags() {
        return { to: `${this.referenceBooksLists.to}/tags` }
    }

    get referenceBookFdLists() {
        return { to: `${this.referenceBooksLists.to}/fd-lists` }
    }

    get referenceBookServicePositions() {
        return { to: `${this.referenceBooksLists.to}/service-positions` }
    }

    get referenceBookB24CompanyPositions() {
        return { to: `${this.referenceBooksLists.to}/b24-company-positions` }
    }

    get referenceBookB24CompanyServices() {
        return { to: `${this.referenceBooksLists.to}/b24-company-services` }
    }

    get referenceBookB24Tasks() {
        return { to: `${this.referenceBooksLists.to}/b24-tasks` }
    }

    get referenceBookB24Entities() {
        return { to: `${this.referenceBooksLists.to}/b24-entities` }
    }

    get referenceBookFunctionDescription() {
        return { to: `${this.referenceBooksLists.to}/function-description` }
    }

    get referenceBookTicketTopics() {
        return {to: `${this.referenceBooksRules.to}/appeals/ticket-topics`}
    }

    get referenceBookTicketTransferReasons() {
        return {to: `${this.referenceBooksRules.to}/appeals/ticket-transfer-reasons`}
    }

    get referenceBookTicketResponseStatuses() {
        return {to: `${this.referenceBooksRules.to}/appeals/ticket-response-statuses`}
    }

    get referenceBookHints() {
        return {
            to: `${this.controlPanel.to}/reference-books/hints`,
        }
    }

    get referenceBookBitrixFields() {
        return { to: `${this.referenceBooksLists.to}/bitrix-fields` }
    }

    get referenceBookOrderStatuses() {
        return {to: `${this.referenceBooksLists.to}/order-statuses`}
    }

    get referenceBookTestingAudience() {
        return {to: `${this.referenceBooksLists.to}/testing-audience`};
    }

    get referenceBookTestingState() {
        return {to: `${this.referenceBooksLists.to}/testing-state`};
    }

    get referenceBookTestingQuestionType() {
        return {to: `${this.referenceBooksLists.to}/testing-question-type`};
    }

    get referenceBookTestingReviewPeriod() {
        return {to: `${this.referenceBooksLists.to}/testing-review-period`};
    }

    get referenceBookTestingAssignmentType() {
        return {to: `${this.referenceBooksLists.to}/testing-assignment-type`};
    }

    get referenceBookTestingRecipient() {
        return {to: `${this.referenceBooksLists.to}/testing-recipient`};
    }

    get referenceBookTestingPreviousAssignment() {
        return {to: `${this.referenceBooksLists.to}/testing-previous-assignment`};
    }

    get referenceBookTestingUnit() {
        return {to: `${this.referenceBooksLists.to}/testing-unit`};
    }

    get partners() {
        return {
            to: `/partners`,
        }
    }

    get referenceBooksChanges() {
        return {
            to: `${this.referenceBooksRules.to}/rb-changes`,
        }
    }

    get referenceBookChangeApproval() {
        return { to: `${this.referenceBooksChanges.to}/change-approval` }
    }

    get referenceBookSyncList() {
        return { to: `${this.referenceBooksChanges.to}/sync-list` }
    }

    get couriers() {
        return { to: '/couriers' }
    }

    get referenceBookFirstTestTypes() {
        return { to: `${this.referenceBooksLists.to}/first-test-types` }
    }

    get referenceBookPartnerCalculatedGroups() {
        return {to: `${this.referenceBooksLists.to}/partner-calculated-groups`}
    }

    get referenceBookPartnerSearchColumnCategories() {
        return {to: `${this.referenceBooksLists.to}/partner-search-column-categories`}
    }

    get referenceBookPartnerFields() {
        return { to: `${this.referenceBooksRules.to}/partner-fields` }
    }

    get referenceBookPartnerFieldCategories() {
        return { to: `${this.referenceBooksRules.to}/partner-field-categories` }
    }

    get referenceBookPartnerFieldSyncRules() {
        return { to: `${this.referenceBooksRules.to}/partner-field-sync-rules` }
    }

    get partnerOnboarding() {
        return { to: `/partner-onboarding` }
    }

    get referenceBookPartnerFieldLists() {
        return { to: `${this.referenceBooksRules.to}/partner-field-lists` }
    }

    get referenceBookPartnerSearchColumns() {
        return {to: `${this.referenceBooksRules.to}/partner-search-columns`}
    }

    get referenceBookFinPermissions() {
        return { to: `${this.referenceBooksRules.to}/fin-permissions` }
    }

    get partnerOnboardingAddresses() {
        return { to: `/partner/onboarding/addresses` }
    }

    get errorSandbox() {
        return { to: `/dev/error-sandbox` }
    }
}
